import { render, staticRenderFns } from "./TalkgroupObject.vue?vue&type=template&id=6c18cbba&scoped=true"
import script from "./TalkgroupObject.vue?vue&type=script&lang=js"
export * from "./TalkgroupObject.vue?vue&type=script&lang=js"
import style0 from "./TalkgroupObject.vue?vue&type=style&index=0&id=6c18cbba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c18cbba",
  null
  
)

export default component.exports